// extracted by mini-css-extract-plugin
export default {"titleSecondPart":"DashboardOfferHeader_titleSecondPart__a3ZBU"};